import React, {Component} from "react";
import PanelGroupController from "../PanelGroupController";
import ActionButton from "../ActionButton";
import FilterPanel from "../panels/FilterPanel";
import {Map, List} from "immutable";

const CONTEXT = "stock";

class StockPanelSet extends Component {

  constructor(props) {
    super(props);
    this.handleAddStock = this.handleAddStock.bind(this);
    this.handleRemoveStock = this.handleRemoveStock.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadWarehouses(this.props.meta);
  }

  render() {
    if (this.props.context !== CONTEXT) return null;

    const noFilterOption = Map({id: "", label: "All"});
    const warehouseOptions = this.props.warehouses.reduce((reduction, x) => {
      return reduction.push(Map({
        id: x.get("id"), 
        label: `${x.get("location")} (${x.get("id")})`        
      }))
    }, List([noFilterOption]));

    return (
      <div className="content">
        <FilterPanel
          expanded={true}
          options={warehouseOptions}
          onClick={(item) => this.props.setStockWarehouseFilter(item.get("id"))}
          filter={this.props.stockWarehouseFilter}
          />

        <PanelGroupController title="Actions">
          <ActionButton label="Add Stock" onClick={this.handleAddStock} />
          <ActionButton label="Remove Stock" onClick={this.handleRemoveStock} />
        </PanelGroupController>
      </div>
    );
  }


  handleAddStock() {
    // Popup window.
    this.props.requestAddStockToWarehouse(this.props.stockWarehouseFilter);
  }

  handleRemoveStock() {
    // Popup window.
    this.props.requestRemoveStockFromWarehouse(this.props.stockWarehouseFilter);
  }

}

export default StockPanelSet;